"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backgroundCircle = exports.root = void 0;

var _reactEmotion = require("react-emotion");

var root =
/*#__PURE__*/
(0, _reactEmotion.css)("transform:rotate(-90deg);circle{fill:none;stroke-linecap:round;}");
exports.root = root;

var backgroundCircle = function backgroundCircle(theme, isDark) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("stroke:", isDark ? theme.color.dark.venus : theme.color.grey3, ";")
  );
};

exports.backgroundCircle = backgroundCircle;